import { render, staticRenderFns } from "./storeLocationListAction.vue?vue&type=template&id=524c828d&scoped=true"
import script from "./storeLocationListAction.vue?vue&type=script&lang=js"
export * from "./storeLocationListAction.vue?vue&type=script&lang=js"
import style0 from "./storeLocationListAction.vue?vue&type=style&index=0&id=524c828d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c828d",
  null
  
)

export default component.exports